import { createSelector } from "@reduxjs/toolkit";
import selectUiRaw from "./selectUiRaw";

export default createSelector(selectUiRaw, ({ imageCropAspectRatio }) => imageCropAspectRatio);

